module.exports = "<div class=\"empty\">\n  <md-icon class=\"empty__icon\" [svgIcon]=\"icon\"></md-icon>\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty.component.html
// module id = ../../../../../src/app/shared/empty/empty.component.html
// module chunks = 4